export enum ContactMode {
  Add = 'add',
  // Configures only the field-update path and suppresses the create action on save.
  Update = 'update',
}
